const selectEventTypeStyles = (theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: 10,

    [theme.breakpoints.down(1000)]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: 10,
    },
  },
  // The Game drawer is a full-height flex column: header + scrollable content take
  // the available space and the footer is pinned to the very bottom regardless of
  // which tab is active or how tall its content is.
  gameContainer: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  // Only the form content scrolls; `minHeight: 0` lets this flex child shrink below
  // its content height so the overflow scrolls instead of pushing the footer down.
  gameScroll: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
  },
  // Negative margins cancel ContainerPadding's 1% inset so the footer's border/
  // background spans the full drawer width.
  gameFooter: {
    flex: 'none',
    marginLeft: '-1%',
    marginRight: '-1%',
  },
  // Same full-bleed technique as the footer so the header's bottom border reaches
  // both drawer edges.
  gameHeader: {
    flex: 'none',
    marginLeft: '-1%',
    marginRight: '-1%',
  },
})

export default selectEventTypeStyles
